export default __webpack_public_path__ + "static/media/chat_empty_state.8c7c5868.svg";